import React, { useEffect } from "react";
import { Spinner, Form } from "react-bootstrap";
import {
  usePageCategoryQuery,
  useUpdatePositionCategoriesMutation,
} from "../../graphql/pageCategory.hooks";
import { Link, useNavigate } from "react-router-dom";
import { Formik, Form as FormikForm, Field, FieldArray } from "formik";

interface ICategoryOrder {
  categoryId: number;
  priority: number;
}

interface IFormValues {
  categories: ICategoryOrder[];
}

export const PageCategory = () => {
  const navigate = useNavigate();

  const { data, loading } = usePageCategoryQuery();
  const [updatePageCategories, { loading: updatingLoading }] =
    useUpdatePositionCategoriesMutation();

  useEffect(() => {
    document.title = "Page Category";
  }, []);

  const moveToCreateForm = () => {
    navigate("/page/category/new");
  };

  if (loading) {
    return (
      <div className="d-flex align-items-center justify-content-center">
        <Spinner animation="border" role="status">
          <span className="visually-hidden">Loading...</span>
        </Spinner>
      </div>
    );
  }

  const initialValues: IFormValues = {
    categories: data.pageCategory.map(({ id, position }) => ({
      categoryId: id,
      priority: position || 0,
    })),
  };

  const handleSubmit = async (values: IFormValues) => {
    await updatePageCategories({
      variables: {
        categoriesPriority: [...values.categories],
      },
    });
  };

  return (
    <div className="container">
      <div className="d-flex justify-content-between align-items-center mb-4">
        <div className="mb-4">
          <h1>Page Category</h1>
        </div>
      </div>

      <div className="g-4 py-5 d-flex flex-column justify-content-center align-items-center bg-white rounded">
        <Formik
          initialValues={initialValues}
          onSubmit={handleSubmit}
          enableReinitialize
        >
          {({ values }) => (
            <FormikForm className="w-100">
              <table className="col-11 mb-5 m-auto">
                <thead>
                  <tr>
                    <th className="d-none d-md-table-cell">Id</th>
                    <th>Title</th>
                    <th className="text-center">Order</th>
                    <th className="text-center">Actions</th>
                  </tr>
                </thead>
                <tbody>
                  <FieldArray name="categories">
                    {() =>
                      values.categories.map((category, index) => {
                        const categoryData = data.pageCategory.find(
                          (c) => c.id === category.categoryId
                        );

                        return (
                          <tr
                            key={category.categoryId}
                            style={{ lineHeight: "2.5" }}
                          >
                            <td className="d-none d-md-table-cell">
                              {category.categoryId}
                            </td>
                            <td>{categoryData?.title}</td>
                            <td className="text-center" style={{ width: 100 }}>
                              <Field
                                name={`categories[${index}].priority`}
                                type="number"
                                as={Form.Control}
                                min="0"
                                max="100"
                                className="numberForm col-12"
                              />
                            </td>
                            <td className="text-center" style={{ width: 180 }}>
                              <Link
                                to={`/page/category/${category.categoryId}`}
                                className="text-primary me-4"
                                style={{ textDecoration: "none" }}
                              >
                                Show
                              </Link>
                              <Link
                                to={`/page/category/${category.categoryId}/edit`}
                                className="text-primary"
                                style={{ textDecoration: "none" }}
                              >
                                Edit
                              </Link>
                            </td>
                          </tr>
                        );
                      })
                    }
                  </FieldArray>
                  {!data.pageCategory.length && (
                    <tr>
                      <td colSpan={4} className="text-center mt-3">
                        No Categories Found
                      </td>
                    </tr>
                  )}
                </tbody>
              </table>

              <div className="d-flex flex-column flex-md-row justify-content-between col-11 col-md-8 m-auto">
                <button
                  type="button"
                  onClick={moveToCreateForm}
                  disabled={loading || updatingLoading}
                  className="btn btn-primary text-white col-12 col-md-4 mb-2 mb-md-0"
                >
                  Create New
                </button>

                <button
                  type="submit"
                  disabled={loading || updatingLoading}
                  className="btn btn-primary text-white col-12 col-md-4"
                >
                  Save Order
                  {updatingLoading && (
                    <Spinner animation="border" role="status" className="ms-2">
                      <span className="visually-hidden">loading...</span>
                    </Spinner>
                  )}
                </button>
              </div>
            </FormikForm>
          )}
        </Formik>
      </div>
    </div>
  );
};
